import Component from './Component';

export default class Product extends Component {

  load() {
    this.initExpandedTextfield();
    super.load();
  }

  initExpandedTextfield() {

    const anchors = document.querySelectorAll('.info__expandbtn');

    // Add click event listeners to all elements
    Array.from(anchors).forEach((anchor) => {
      anchor.addEventListener('click', () => {
        const textArea = document.querySelector('.info__overview');
        // console.log('click. Change', textArea);

        textArea.classList.toggle('expanded');
        if(textArea.classList.contains('expanded')) {
          anchor.innerHTML = 'Show Less';
        } else {
          anchor.innerHTML = 'Show More';
        }
      });
    });

  }

}
